import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { Clapperboard } from "lucide-react";
import api from "@/lib/api";
import SectionHeading from "@/components/SectionHeading";
import { useSectionContent } from "@/hooks/useContent";

export default function VideoGiri() {
  const c = useSectionContent("video");
  const { data: videos = [] } = useQuery({
    queryKey: ["videos"],
    queryFn: async () => (await api.get("/videos")).data,
  });

  if (videos.length === 0) return null;

  return (
    <section id="video" data-testid="video-section" className="py-24 sm:py-32 px-5 sm:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          overline={c.overline}
          title={c.title}
          description={c.description}
          testid="video-heading"
        />

        <div className="mt-14 grid md:grid-cols-2 gap-6" data-testid="videos-grid">
          {videos.map((video, i) => (
            <motion.article
              key={video.id}
              data-testid={`video-card-${video.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="leather-card overflow-hidden"
            >
              <div className="relative bg-black aspect-video">
                <video
                  controls
                  preload="metadata"
                  poster={video.poster_url || undefined}
                  src={video.video_url}
                  className="w-full h-full"
                  data-testid={`video-player-${video.id}`}
                />
              </div>
              <div className="p-5 flex items-center gap-3">
                <Clapperboard className="w-4 h-4 text-[#C5A059] shrink-0" />
                <h3 className="font-display text-lg font-semibold text-[#F4EBE1]">{video.title}</h3>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
